import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const Svg4VSideViewTableUp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M44 19.164 33.032 11H13.79L2.823 19.164l20.588 19.159zm-6.154 1.629L23.411 34.226 8.977 20.793zM32.038 14l5.095 3.792H9.69L14.784 14z" })
});
export default Svg4VSideViewTableUp;
